import React, { Fragment, useState } from "react";
import { Modal, ModalHeader, ModalBody, Button } from "reactstrap";
import CustomerDetails from "./modal-components/customer-details";
import VehicleDetails from "./modal-components/vehicle-details";
import PolicyDetails from "./modal-components/policy-details";
import ProductDetails from "./modal-components/product-details";
import TaxDetails from "./modal-components/tax-details";
import { ModalFooter } from "react-bootstrap";
import CommunicationDetails from "./modal-components/communication-details";
import { Nav, NavItem, NavLink, TabContent, TabPane } from 'reactstrap'
import ClientDealership from "./modal-components/client-dealership-details";
import { useEffect } from "react";
import { getDocumentById, getPolicyDetailsById } from "../../../../api";
import ChangeHistoryDetails from "./modal-components/change-history-details";
import GetLoader from "../../../common/getLoader";
import NomineeDetails from "./view-policy-modals/nominee-details";
import ProposerDetails from "./view-policy-modals/proposer-details";
import PlanDetails from "./view-policy-modals/plan-details";
import TravellerDetails from "./view-policy-modals/traveller-details";
import JourneyDetails from "./view-policy-modals/journey-details";
import { getFromLocalStorage } from "../../../../hooks/useLocalStorage";
import DocumentDetails from "./view-policy-modals/document-details";
import SettlementDetails from "./view-policy-modals/settlement-details";


const ViewPolicyModal = ({ isOpen, toggle, selectedPolicyData, salesPolicyId }) => {
    const currentRole = getFromLocalStorage('ROLE');
    const [viewPolicyDetailsByType, setViewPolicyDetailsByType] = useState(0);
    const [loading, setLoading] = useState(false);
    const [documentDetails, setDocumentDetails] = useState({});
    const [createdDetails, setCreatedDetails] = useState({});
    const [invoiceData, setInvoiceData] = useState({});
    const [ticketData, setTicketData] = useState({});
    const [communicationData, setCommunicationData] = useState({});
    const [commissionData, setCommissionData] = useState({});
    const [userWalletHistory, setUserWalletHistory] = useState({});
    const [transactionDetails, setTransactionDetails] = useState({});
    const [commissionTransactionDetails, setCommissionTransactionDetails] = useState({});
    const [cNDetails, setCNDetails] = useState({});
    const [offlineTicketData, setOfflineTicketData] = useState({});
    const [quotationDetails, setQuotationDetails] = useState({});
    const [journeyData, setJourneyData] = useState({});
    const [hoColumn] = useState(getFromLocalStorage('ROLE')?.key == "HO" ? true : false);

    const fetchDocumentDetails = async () => {
        setLoading(true);
        try {
                const document_id = selectedPolicyData?.document_id || salesPolicyId;
                const res = await getDocumentById(document_id);
                console.log(res, 'document data');
                setDocumentDetails(res.data?.result?.document);
                setInvoiceData(res.data?.result?.document_invoice_details || {});
                setTicketData(res.data?.result?.tickets || []);
                setCreatedDetails(res.data?.result?.created_user_details || {});
                setCommunicationData(res.data?.result?.document_transaction_history);
                setCommissionData(res.data?.result?.commission_details || {});
                setUserWalletHistory(res.data?.result?.user_wallet_history_details || {});
                setTransactionDetails(res.data?.result?.transaction_details || {});
                setCommissionTransactionDetails(res.data?.result?.commission_transaction_details || {});
                setCNDetails(res.data?.result?.cn_details || {})
                setQuotationDetails(res.data?.result?.quotation_details || {});
                setOfflineTicketData(res.data?.result?.offline_ticket_details || {});
        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
    }

    let steps = [
        { key: 0, name: 'Proposer', component: <ProposerDetails data={documentDetails} /> },
        { key: 1, name: 'Traveller', component: <TravellerDetails data={documentDetails} /> },
        { key: 2, name: 'Nominee', component: <NomineeDetails data={documentDetails} /> },
        { key: 3, name: 'Document', component: <DocumentDetails data={documentDetails} invoice={invoiceData} createdDetails={createdDetails} /> },
        { key: 4, name: 'Settlement', component: <SettlementDetails data={documentDetails} invoice={invoiceData} commission={commissionData} communicationData={communicationData} userWalletHistory={userWalletHistory} transactionDetails={transactionDetails} commissionTransactionDetails={commissionTransactionDetails} cNDetails={cNDetails} quotation= {quotationDetails} offlineTicketData= {offlineTicketData}/>},
       //  { key: 3, name: 'Plan', component: <PlanDetails data={documentDetails} /> },
        { key: 5, name: 'Plan', component: <PlanDetails data={documentDetails} /> },
        { key: 6, name: 'Communication', component: <CommunicationDetails data={communicationData} documentStatus={documentDetails?.status} documentId={documentDetails?.document_id} documentUniqueCode={documentDetails?.document_unique_code} onRefresh={fetchDocumentDetails} /> },
        {key: 7, name: 'History', component: <ChangeHistoryDetails data={ticketData} /> },
        {key: 8, name: 'Journey', component: <JourneyDetails data={documentDetails} /> },
        // { key: 0, name: 'Customer', component: <CustomerDetails data={policyData} /> },
        // { key: 1, name: 'Dealership', component: <ClientDealership data={documentDetails} /> },
        // { key: 2, name: 'Vehicle', component: <VehicleDetails data={documentDetails} /> },
        // { key: 3, name: 'Policy', component: <PolicyDetails data={documentDetails} /> },
        // { key: 4, name: 'Product', component: <ProductDetails data={documentDetails} /> },
        // { key: 5, name: 'Tax', component: <TaxDetails data={documentDetails} /> },

    ]

    if(!hoColumn) {
        steps = steps.filter(step => step?.key <= 6);
    }

    // Check if policyData.communication exists and its length is not equal to 0
    // if (policyData.communication && policyData.communication.length !== 0) {
        // steps.push({ key: 6, name: 'Communication', component: <CommunicationDetails data={policyData} /> });
    // }

    // Check if policyData.communication exists and its length is not equal to 0
    // if (documentDetails.tickets && documentDetails.tickets.length !== 0) {
    //     steps.push({ key: 7, name: 'History', component: <ChangeHistoryDetails data={documentDetails} isHistoryTabTrigger={true} /> },);
    // }
    



    const handleNextTabByClick = (nextStepValue, steps) => {
        if (nextStepValue < steps.length) {
            // console.log(viewPolicyDetailsByType, 'viewPolicyDetailsByType');
            setViewPolicyDetailsByType(viewPolicyDetailsByType + 1);
        }
    }

    const handlePreviousTabByClick = (previousStepValue, steps) => {
        if (previousStepValue >= 0) {
            setViewPolicyDetailsByType(viewPolicyDetailsByType - 1);
        }
    }

    // let sales_policy_id;
    // if (selectedPolicyData?.policy?.sales_policy_id) {
    //     sales_policy_id = selectedPolicyData?.policy?.sales_policy_id
    // } else if (selectedPolicyData?.sales_policy_id) {
    //     sales_policy_id = selectedPolicyData?.sales_policy_id
    // }

    useEffect(() => {
        fetchDocumentDetails();
    }, []);

    return (
        <Fragment>

            <Modal isOpen={isOpen} toggle={toggle} size={currentRole != 'DEALERSHIP_MANAGER' || currentRole != 'DEALER_SALES_PERSON' ? 'xl' : 'lg'} backdrop="static">
                <ModalHeader toggle={toggle} className="pb-0 border-0">
                    {"Document Details"}
                </ModalHeader>
                <ModalBody className="pt-4">

                    {loading ? <GetLoader /> : (
                        <>

                            <Nav className="nav-pills nav-justified">
                                {
                                    steps && steps.map((item, i) => {
                                        return (
                                            <NavItem key={i}>
                                                <NavLink href="#javascript" className={viewPolicyDetailsByType === item.key ? 'active' : ''} onClick={() => setViewPolicyDetailsByType(item.key)}>
                                                    <span style={{ whiteSpace: 'nowrap' }}> {item.name} </span>
                                                </NavLink>
                                            </NavItem>
                                        )
                                    })
                                }
                            </Nav>
                            <TabContent activeTab={viewPolicyDetailsByType}>
                                {
                                    steps && steps.map((item, i) => {
                                        return (
                                            <TabPane className={item.key === 0 ? "fade show" : ""} tabId={item.key} key={i}>
                                                {item.component}
                                            </TabPane>
                                        )
                                    })
                                }
                            </TabContent>
                        </>

                    )}

                </ModalBody>
                <ModalFooter>
                    <div className="container-fluid">
                        <div className="row">
                        <div className="col-6">
                        {parseInt(viewPolicyDetailsByType) !== 0 && (
                            <Button
                            className="mr-2 btnCustom"
                            outline
                            color="info"
                            size="md"
                            onClick={(e) => handlePreviousTabByClick(parseInt(viewPolicyDetailsByType) - 1, steps)}
                            >
                            {"Previous"}
                            </Button>
                            )}
                        </div>
                        <div className="col-6 text-right">
                            {parseInt(viewPolicyDetailsByType) < steps.length - 1 && (
                            <Button
                                className="btnCustom"
                                outline
                                color="info"
                                size="md"
                                onClick={(e) => handleNextTabByClick(parseInt(viewPolicyDetailsByType) + 1, steps)}
                            >
                                {"Next"}
                            </Button>
                            )}
                        </div>
                        </div>
                    </div>
                </ModalFooter>
            </Modal>
        </Fragment>
    );
};

export default ViewPolicyModal;
